<template>
    <div  @keydown="checkSlide($event)" tabindex="0">
                <slot></slot>
        <div>
            <button style="background-color:transparent;border:0px solid transparent;" @click.prevent="next" class="btn2 btn-next2"><i class="fa fa-angle-right"><base-icon width="50" height="50"  src="/static-appopensalud/img/icons/noun-arrow-blue.svg" class="ml-2" color="blue"/></i></button>
            <button style="background-color:transparent;border:0px solid transparent;" @click.prevent="prev" class="btn2 btn-prev2"><i class="fa fa-angle-right"><base-icon width="50" height="50" src="/static-appopensalud/img/icons/noun-arrow-blue.svg" class="ml-2" color="blue"/></i></button>
        </div>
        
    </div>
</template>
<script>
export default {
    data () {
        return {
            index: 0,
            slides: [],
            slideDirection: ''
        }
    },
    computed: {
        slidesLength () {
            return this.slides.length
        }
    },
    mounted () {
        this.$children.pop()
        this.$children.pop()
        this.slides = this.$children
        this.slides.map((slide, index) => {
            slide.index = index
        })
        // window.setInterval(() => {
        //     this.next()
        // }, 7000)
    },
    methods: {
        next () {
            this.index++
            if (this.index >= this.slidesLength) {
                this.index = 0
            }
            this.slideDirection = 'slide-right'
        },
        prev () {
            this.index--
            if (this.index < 0) {
                this.index = this.slidesLength - 1
            }
             this.slideDirection = 'slide-left'
        },
        checkSlide (event) {
            if (event.keyCode === 26) {
                this.next()
            } else if (event.keyCode === 26) {
                this.prev()
            } else {
            }
        }
    }
}
</script>
<style lang="scss">
.carousel {
    // align-items: center;
    // width: 340px;
      @include desktop {
      position:relative;
        overflow: initial;
        
  }

  @include desktop-sm {
  position:relative;
        overflow: initial;
          }

  @include media(mobile, tablets) {
      position:initial;
        overflow: initial;
        // width:100vw;
       
    }
  }
 .btn2 {
        top:12rem;
        background-color:transparent;
        border:0px solid transparent;
        color:rgb(0, 0, 0);
        position:absolute;
        z-index:2;
         @include mobile {
          top:15rem !important;
          padding: 5rem 3rem;
          margin-bottom: 3rem;
          min-height: 280px;
        }
    }
    .button-line{
        position: relative;
        border-top: 1px solid black;
                vertical-align:bottom;
                flex-direction: column;
                top:2rem;
    }
   .btn:hover {
        cursor: pointer;
    }
    .btn:focus{
        outline:none;
    }
    .btn-next2 {
                vertical-align:bottom;
         @include desktop {
            left:0;
            display: flex;
        }
        @include desktop-sm {
            left:0;
            display: flex;
        }
         @include tablets {
            left:0;
            display: flex;
        }
        @include mobile {
            left:0;
        transform: rotate(-180deg);
        }
        
    }
    .btn-prev2 {
        vertical-align:bottom;
        @include desktop {
            right:0;
            display: flex;

        }
        @include desktop-sm {
            right:0;
            display: flex;

        }
         @include tablets {
            right:0;
            display: flex;

        }
        @include mobile {
            right:0;
        }
    }
    .carousel-slider {
        position:absolute;
    }
    .carousel-slider img {
        width:60%;
        height:60%;
        border-radius: 50%;
    }
</style>


// WEBPACK FOOTER //
// src/components/base/carousel/Carousel.vue